// Segmented control for the two GIS View layouts (drives split.full). Lives in the PanelTabs right
// slot, beside the entity/date filters — Split = map + panel, Full = map hidden, panel full width.

import type { ReactNode } from 'react'

import { PanelRight, Square } from 'lucide-react'

import { SegmentedControl } from '../ui/SegmentedControl'

interface ViewModeToggleProps {
  /** `true` = Full Analytics (map hidden, panel full width); `false` = Split View (map + panel). */
  full: boolean
  /** Flips `split.full`. Fires only when the picked mode differs from the current one. */
  onToggle: () => void
}

type ViewMode = 'split' | 'full'

const ITEMS: { key: ViewMode; label: ReactNode }[] = [
  {
    key: 'split',
    label: (
      <span className="flex items-center gap-[5px]">
        <PanelRight className="h-3 w-3 stroke-[2.2]" aria-hidden />
        Split
      </span>
    ),
  },
  {
    key: 'full',
    label: (
      <span className="flex items-center gap-[5px]">
        <Square className="h-3 w-3 stroke-[2.2]" aria-hidden />
        Full
      </span>
    ),
  },
]

export function ViewModeToggle({ full, onToggle }: ViewModeToggleProps) {
  const value: ViewMode = full ? 'full' : 'split'
  return (
    <SegmentedControl<ViewMode>
      items={ITEMS}
      value={value}
      // Guarded: only flip when the direction actually changes (no double-toggle-off).
      onChange={(next) => {
        if (next !== value) {
          onToggle()
        }
      }}
      size="sm"
      track="a"
      shape="rounded"
    />
  )
}
